export default "__VITE_ASSET__3ee869a9__"